import { capitalize } from "lodash";

export { capitalize };

export type TitleCase<
  T extends string,
  D extends string = " ",
> = string extends T
  ? never
  : T extends `${infer F}${D}${infer R}`
  ? `${Capitalize<F>}${D}${TitleCase<R, D>}`
  : Capitalize<T>;

export const toTitleCase = <V extends string>(value: string): TitleCase<V> =>
  value.length === 0
    ? ("" as TitleCase<V>)
    : value.length === 1
    ? (value[0].toUpperCase() as TitleCase<V>)
    : (`${value[0].toUpperCase()}${value
        .substring(1)
        .toLowerCase()}` as TitleCase<V>);

export const capitalizeSnakeCaseString = (string: string) => {
  const list = string
    .split("_")
    .map((text) => capitalize(text.toLowerCase()))
    .join(" ");
  return list;
};

export const capitalizeStringWithSpace = (string: string) => {
  const list = string
    .split(" ")
    .map((text) => capitalize(text.toLowerCase()))
    .join(" ");
  return list;
};

export const formatStringToReadableText = (string: string) => {
  // if url then return as is
  if (string.includes(".com")) {
    return string;
  }

  // if snake case, then use formatSnakeCaseText
  if (string.includes("_")) {
    return capitalizeSnakeCaseString(string);
  }

  // if words with space then break up the space
  if (string.includes(" ")) {
    return capitalizeStringWithSpace(string);
  }

  return capitalize(string.toLocaleLowerCase());
};
